<template>
  <HeaderStepBlockDesktop v-if="!isMobile"/>
  <HeaderStepBlockMobile v-if="isMobile"/>
</template>

<script>
import HeaderStepBlockDesktop from "@/components/steps/header-step-block/HeaderStepBlockDesktop";
import HeaderStepBlockMobile from "@/components/steps/header-step-block/HeaderStepBlockMobile";

export default {
  name: "HeaderStepBlock",
  components: {HeaderStepBlockMobile, HeaderStepBlockDesktop},
  data() {
    return {
      isMobile: null,
    }
  },
  methods: {
    updateWidth() {
      if(window.innerWidth < 1024) {
        this.isMobile = true;
      } else{
        this.isMobile = false;
      }
    },
  },
  created() {
    window.addEventListener('resize', this.updateWidth);
    this.updateWidth();
  },
}
</script>

<style scoped>

</style>